import { ProductImageFragment } from '@/fo/api/magento';

import { Image } from '../types';

export const imageMapper = (image: ProductImageFragment): Image => {
  if (!image) return null;

  return {
    src: image.src || '',
    alt: image.alt || ''
  };
};
